import store from '@/store'
import { tkParse } from '@moke/vue-tk'
// import superPer from '../core/permissions.yaml'
export default async () => {
  // 获得今年年份
  let date = new Date()
  store.commit('setYear', date.getFullYear())
  // 自动登录判断
  if (!store.state.sessionToken) {
    store.commit('clearUser')
    return
  }
  tkParse.setSessionToken(store.state.sessionToken)
  await tkParse.getData('/users/me')
    .then(async (user) => {
      await store.dispatch('initUser', user)
    })
    .catch(e => {
      tkParse.setSessionToken(null)
      store.commit('clearUser')
    })
}
